export default "__VITE_ASSET__fe248948__"